import React, { useEffect } from "react"
import { AppIconChipToggle } from "@components"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData, useManualExecution } from "Pages/ReportsAlerts/Reports/@signals"
import { boolean, object } from "yup"


export default function ReportManualExecutionSwitch() {

	const {
		manuallyExecution,
		setManuallyExecutionInfo
	} = useReportFormInfo(reportFormData.peek()?.manuallyExecution, "manuallyExecution", object({ manuallyExecution: boolean() }))

	useEffect(() => {
		useManualExecution.value = manuallyExecution
	}, [manuallyExecution])

	return <AppIconChipToggle
		aria-label="How it runs"
		value={!!manuallyExecution}
		options={[
			{ value: false, label: 'Scheduled', icon: 'clock' },
			{ value: true, label: 'Manual execution', icon: 'hand-pointer' },
		]}
		onChange={value => setManuallyExecutionInfo(value)}
	/>
}